import { useStore } from "../../../hooks/use-store";
import { observer } from "mobx-react";
import { Button, Flex } from "@mantine/core";

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import List from 'react-virtualized/dist/commonjs/List';
import PipelineItem from "./PipelineItem";
import { useRequest } from "ahooks";
import { useWindowSize } from "../../../helpers/helper";

const History = (model: {
    addFeatured: (model: string) => Promise<void>
    searchInMaground: (model: string) => Promise<void>
    searchInHdrMaground: (model: string) => Promise<void>

    onRemoveObject: (model: string) => Promise<void>
    onFillCarObject: (model: string) => Promise<void>

    // audiThMode
    openCustomModelVersion: (version: string, prompt: string, ratio: string) => Promise<void>
    openBillingModal: () => Promise<void>
    onUpscale: (model: string, type: 'TOPAZ' | 'TOPAZ_ENHANCED' | 'FREEPIK') => Promise<void>
    onUpscaleHdrV1: (model: string, type: '4k' | '6k' | '8k') => Promise<void>
    makeVariations: (model: string) => Promise<void>
    placeCar: (model: string) => Promise<void>
    onEnlarge: (model: string) => Promise<void>
    onMoodEnhance: (model: string) => Promise<void>
    onAiRetouch3: (model: string) => Promise<void>
    onAiRetouch2: (model: string) => Promise<void>
    onCameraRotate: (model: string) => Promise<void>
    changeBackground: (model: string) => Promise<void>
    onInpaint: (model: string) => Promise<void>
    create360: (model: string) => Promise<void>
    createHDR: (model: string) => Promise<void>
    loadMore: () => Promise<void>

}) => {
    const {
        dataStore: { spaceStore, appStore },
        uiStore: { authStore },

    } = useStore();

    const windowSize = useWindowSize()
    const secretModeEnabled = authStore.currentUser?.id === 'user_ncW1SxIG5X3mwQGtmPp5Z' || authStore.currentUser?.id === 'user_ztvePOlS8Ylq0N0c5wFhK' || authStore.currentUser?.id === 'user_RzgcIMD1nu3VgXxx1ohCx' || authStore.currentUser?.id === 'user_bwxZh45ttxCf6U3MQeJCc'
    const audiThMode = authStore.currentUser?.id === 'user_GFlUPjOFZH7yzZZCnkP2-' || authStore.currentUser?.id === 'user_i4v9e-_x7c6houFvhfi10' || secretModeEnabled
    const ravMode = authStore.currentUser?.id === 'user_qahcavTEExbZY-TtoSddx' || authStore.currentUser?.id === 'user_jVMWLWkLVwH8xGdTRXby9' || authStore.currentUser?.id === 'user_hnoyZAeojfB2fFVysq_ER' || secretModeEnabled

    const { runAsync: runUpdateRatingPipeline } = useRequest(
        async (model: { id: string, rating: number }) =>
            appStore.runUpdateRatingPipeline(model),
        {
            loadingDelay: 20,
            manual: true,
            onSuccess: (model) => {
                // authStore.syncUser();
            },
        }
    );

    return <>
        <Flex
            direction={'column'}
            w="100%"
            h={'100vh'}
            gap={8}
            style={{

            }}>

            {
                spaceStore.pipelines.length > 0 ? <AutoSizer>
                    {({ width }) => (
                        <>
                            <List
                                height={windowSize.height ? windowSize.height - 100 : 1000}
                                overscanRowCount={10}
                                rowCount={spaceStore.pipelines.length > 90 ? spaceStore.pipelines.length +1 : spaceStore.pipelines.length}
                                rowHeight={700}
                                rowRenderer={({ index, isScrolling, key, style }) => {
                                    const pipeline = spaceStore.pipelines[index]

                                    if (index === spaceStore.pipelines.length && spaceStore.pipelines.length > 90) {
                                        return <Flex direction={'column'} key={key} h={'600px'} style={style}>
                                            <Flex justify={'center'} w={'100vw'}>
                                                <Button
                                                    mt={10}
                                                    mb={60}
                                                    w={'200px'}
                                                    color="orange"
                                                    onClick={() => {
                                                        model.loadMore()
                                                    }}>
                                                    Load more
                                                </Button>
                                            </Flex>
                                        </Flex>
                                    }
                                    return (
                                        <Flex direction={'column'} key={key} h={'600px'} style={style}>
                                            {/* HELLO {index} */}
                                            <PipelineItem
                                                {
                                                ...model
                                                }
                                                onUpdateRating={async (rating: number) => {
                                                    await runUpdateRatingPipeline({
                                                        id: pipeline.data.jobId,
                                                        rating,
                                                    })

                                                    // Update the local spaceStore
                                                    spaceStore.updatePipeline({
                                                        data: {
                                                            ...pipeline.data,
                                                            rating: rating
                                                        },
                                                        status: pipeline.status
                                                    }, pipeline.data.jobId)
                                                }}
                                                rating={spaceStore.rating}
                                                secretModeEnabled={secretModeEnabled}
                                                audiThMode={audiThMode}
                                                ravMode={ravMode}

                                                big={spaceStore.big}
                                                dark={index % 2 === 0}
                                                pipeline={{
                                                    ...pipeline.data,
                                                    status: pipeline.status,
                                                }}

                                            />
                                        </Flex>
                                    )
                                }}
                                width={width}
                            />


                        </>
                    )}
                </AutoSizer> : null
            }

        </Flex>
    </>
}

export default observer(History);